export const Routes = {
  Home: '/home',
  MyAccount: '/my-account',
  Admin: '/admin.do',
  Teams: '/admin',
  Login: '/login',
  Logout: '/logout',
  UserGuide: '/userguide',
  Training: '/home?page=training',
  Glossary: '/home?page=glossary',
  UserGuidePDF: '/downloadUserSupportMaterial/manual.pdf',
  ProductRoadMapPDF:
    '/downloadUserSupportMaterial/vantage-external-product-roadmap.pdf',
  FaqPDF: '/downloadUserSupportMaterial/vantage-faq.pdf'
}
